import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import { ProjectInput } from '@app/core/model/entities/project/project';
import {
  ProjectCreateModalComponent
} from '@app/features/main/views/projects/projects-inventory/modals/project-create-modal/project-create-modal.component';

@Component({
  templateUrl: './asset-project-create-modal.component.html',
  standalone: false
})
export class AssetProjectCreateModalComponent extends ProjectCreateModalComponent {
  private asset = inject<{ asset: Asset }>(MAT_DIALOG_DATA).asset;
  public formId = 'asset_project_creation_dialog';

  /**
   * @return Project data.
   */
  public getGeneratedObject(): ProjectInput {
    return {
      ...this.projectInput,
      assetIds: [this.asset.id]
    };
  }
}
